import MuiTooltip, {
  TooltipProps as MuiTooltipProps,
} from '@mui/material/Tooltip';

import { Box } from './Box';
import { Typography } from './Typography';

export interface TooltipProps extends MuiTooltipProps {
  variant?: 'light' | 'dark';
}

export const Tooltip: React.FC<TooltipProps> = ({
  variant = 'dark',
  slotProps,
  title,
  children,
  ...props
}) => {
  if (variant === 'dark') {
    return (
      <MuiTooltip title={title} slotProps={slotProps} {...props}>
        {children}
      </MuiTooltip>
    );
  }
  return (
    <MuiTooltip
      {...props}
      title={
        <Typography color="text.primary" component="div" className="light">
          {title}
        </Typography>
      }
      slotProps={{
        ...slotProps,
        tooltip: {
          ...slotProps?.tooltip,
          sx: (theme) => {
            return {
              backgroundColor: 'white',
              border: `1px solid ${theme.palette.neutral[200]}`,
            };
          },
        },
      }}
    >
      <Box>{children}</Box>
    </MuiTooltip>
  );
};
